<template>
  <div style="height: 100%; background: #fff">
    <div class="overflow">
      <div v-if="!checkShowDarkCard" class="type-title">
        <img :src="typeImg" />
        <div class="text-gray1">{{ typeText }}</div>
      </div>
      <div v-else class="dark-card">
        <div class="info">{{ typeText }}</div>
        <div class="main" v-if="type === 'waterFee' || type === 'taiwanWaterFee'">
          {{ formatSpace(parameter1) }}
        </div>
        <div class="main" v-if="type === 'cableFee'">
          {{ billerNickName }}
        </div>
        <div class="main" v-if="type === 'roadsideParking'">
          {{ parameter2 }}
        </div>
        <div class="main" v-if="type === 'carFuelFee'">
          {{ parameter1 }}
        </div>
        <div class="main" v-if="type === 'telcomFee'">
          {{ formatTelcomEquipmentNumber1(parameter1) }}
        </div>
        <div class="main" v-if="type === 'healthyInsurance'">
          全民健康保險費
        </div>
        <div class="main" v-if="type === 'medicalFee'">
          <div>聯合醫院 {{ formatBranchCodeToBranchName(parameter3) }} 院區</div>
          <div style="font-size: 16px">{{ parameter1.slice(0, 1) }}*****{{ parameter1.slice(6, 10) }}</div>
        </div> 
        <div class="main" v-if="type.toUpperCase().indexOf('TUITIONFEE')!==-1">學雜費</div>
        <div class="main" v-if="type === 'tax'">{{ paymentItemId === '14' ? billList[0].field1_value : billList[0].field2_value }}</div>
        <div class="main" v-if="type === 'electricFee'">{{ formatSpace(billList[0].field1_value) }}</div>
      </div>
      <div class="annotation" v-if="this.annotation!==''" v-html="this.annotation"></div> 
      <div class="list">           
        <div v-for="(item, i) in billList" :key="i" class="item" @click.prevent="clickBill(item)">
          <div :class="item.is_allow_payment ? 'row' :'row row-disable'">    
            <div class="flex">
              <div class="text-gray2">
                <!--台灣水費-->
                <template v-if="type === 'taiwanWaterFee'">
                  <span style="font-size: 16px" class="text-md">{{item.field2_value}} 台灣自來水費</span>
                  <span style="font-size: 12px" class="text">用水度數：{{ item.field4_value }}度</span>-
                </template>

                <template v-if="type === 'carFuelFee'">
                  <span style="font-size: 16px" class="text-md" v-if="item.field5_value !== ''">{{item.field5_value}}</span>
                  <span style="font-size: 12px" class="text">管轄單位：{{ item.field6_value }}</span>
                  <span style="font-size: 12px" class="text">年度期別：{{ item.field3_value + item.field3_name + ' ' + item.field4_value}}</span>
                  <span style="font-size: 12px" class="text">{{ item.field7_name }}：</span>            
                  <span style="font-size: 12px" class="text">{{ item.field7_value }}</span>            
                  <span style="font-size: 12px; color: #00a12d;" class="text" v-if="item.is_allow_payment">{{ item.field8_name + '：' + item.field8_value }}</span>
                  <span style="font-size: 12px; color: #da2626;" class="text" v-if="!item.is_allow_payment">{{ item.field8_name + '：' + item.field8_value }}</span>
                </template>

                <!--健保費-->
                <template v-if="type === 'healthyInsurance'">
                  <span style="font-size: 12px" class="text">銷帳編號</span>
                </template>
                
                <template v-if="type !== 'tuitionFee' && type !== 'otherTuitionFee' && type !== 'taiwanWaterFee' && type !== 'carFuelFee' && type !== 'electricFee' && type !== 'telcomFee'">
                  <span style="font-size: 16px" class="text">{{ item.payment_custom_id || item.field1_value }}</span>
                  <!--<br />-->
                </template>

                <template v-if="type === 'electricFee'">
                  <span style="font-size: 16px" class="text">{{ formatSpace(item.field1_value) }}</span>
                  <span style="font-size: 12px" class="text">{{ item.field2_value.substr(0, 4) + '/' + item.field2_value.substr(4, 2) + ' ' + item.field4_value + (item.field4_value==='電費' ? ('(' + item.field5_value + '度)') : '') }}</span>
                  <span style="font-size: 12px" class="text">收費日：{{ item.field3_value }}</span>
                </template>

                <template v-if="type === 'telcomFee'">
                  <span style="font-size: 16px" class="text">電信費 ({{ item.field3_value }})</span>
                  <span style="font-size: 12px" class="text">繳費期限：{{ item.bill_end_time.substr(0, 10) }}</span>
                  <span style="font-size: 12px" class="text">機構代碼：{{ item.field1_value }}</span>
                  <span style="font-size: 12px" class="text">帳單識別：{{ item.field4_value }}</span>
                  <span style="font-size: 12px; color: #00a12d;" class="text" v-if="item.is_allow_payment">{{ item.field5_value }}</span>
                  <span style="font-size: 12px; color: #da2626;" class="text" v-if="!item.is_allow_payment">{{ item.field5_value }}</span>
                </template>

                <!--路邊停車-->
                <template v-if="type === 'roadsideParking'">
                  <template v-if="paymentItemId === 'tainan-CAR' || 
                  paymentItemId === 'hsinchu-CAR' || 
                  paymentItemId === 'hsinchuCity-CAR' || 
                  paymentItemId === 'kaohsiung-CAR' || 
                  paymentItemId === 'nantou-CAR' || 
                  paymentItemId === 'newTaipeiCity-CAR' ||
                  paymentItemId === 'keelung-CAR' || 
                  paymentItemId === 'taoyuan-CAR' ||
                  paymentItemId === 'taichung-CAR' ||
                  paymentItemId === 'yilan-CAR'">
                    <span style="font-size: 12px" class="text">{{ item.field3_name }}：{{ item.field3_value }}</span>
                  </template>
                  <template v-else>
                    <span style="font-size: 12px" class="text">{{ item.field2_name }}：{{ item.field2_value }} {{ item.field3_value }}</span>
                    <br />
                  </template>
                </template>

                <!--學雜費-->
                <template v-if="type === 'tuitionFee'">
                  <span class="text" style="font-size: 16px">{{ item.field2_value | hideName }}</span>
                  <span style="font-size: 12px" class="text">繳費單號：{{ item.payment_custom_id }}</span>
                </template>

                <!--非台北市之學雜費-->
                <template v-if="type === 'otherTuitionFee'">
                  <template v-if="parameter1 === 'newTaipeiCity'">
                    <span class="text-gray2" style="font-size: 16px">{{ item.field10_value | hideName }}</span>
                    <span class="text" style="font-size: 12px">繳費單號：{{ item.field3_value }}</span>
                  </template>
                  <template v-else>
                    <span class="text-gray2" style="font-size: 16px">{{ billerNickName }}</span>
                    <span class="text" style="font-size: 12px">{{ item.field3_value | hideName }}</span>
                  </template>
                  <span style="font-size: 12px" class="text">{{ item.field1_name }}：{{ item.field1_value }}</span>                
                </template>

                <!--有線電視費-->
                <template v-if="type === 'cableFee'">
                  <span class="text-gray2" style="font-size: 16px">帳單編號 {{ item.orderNo }}</span>
                  <span class="text" style="font-size: 12px">繳費期限：<span :style="cableFeeExpiredDateStyle(item.expire_date)">{{ formatCableFeeExpiredDate(item.expire_date) }}</span></span>
                </template>
                
                <span v-if="type !== 'gasFee' && 
                  type !== 'taiwanWaterFee' && 
                  type !== 'otherTuitionFee' &&
                  type !== 'cableFee' &&                
                  type !== 'electricFee' &&
                  type !== 'carFuelFee' &&
                  type !== 'healthyInsurance' && 
                  type !== 'telcomFee'" style="font-size: 12px" class="text">繳費期限：{{ item.bill_end_time }}</span>

                <span v-if="type === 'roadsideParking' && !item.is_allow_payment" class="error-text">無法繳費，請洽{{ typeText.split(' ')[0] }}停管處</span>

              </div>
              <div class="right">
                <div class="amount">${{ formatAmt(item.amt) }}</div>
                <div class="agree-label">
                  <input type="checkbox" :id="item.payment_custom_id" v-model="item.checked" :disabled="item.disabled || !item.is_allow_payment" />
                  <label :for="item.payment_custom_id"></label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="empty-block" :style="this.goPayStyle()"></div>
    </div>
    <div class="div-pay" v-bind:style="this.goPayStyle()" v-if="billListLength">
      <div class="div-pay-type" @click="showPayTypeList">
        <div class="text-sm">付款方式</div>
        <div class="pay-select">
          <img :src="checkedPayType.paymentMethodImageUrl" />
          <div id="select_pay">
            <span style="font-family: PingFangTC-Medium">{{ checkedPayType.paymentMethodName }}</span>
            <span style="font-family: PingFangTC-Regular">{{ checkedPayType.paymentMethodRemark }}</span>
          </div>
        </div>
      </div>
      <div class="div-carrier-number" @click="editCarrierNumber" v-if="this.shouldShowCarrierNumber()">
        <div class="text-sm">手機條碼載具（選填）</div>
        <div class="carrier-number">
          <template v-if='this.verifiedCarrierNumber === null'>
            <span style="font-family: PingFangTC-Medium; color: #404040; opacity:0.4">尚未填寫手機條碼載具</span>
          </template>
          <template v-if='this.verifiedCarrierNumber !== null'>
            <span style="font-family: PingFangTC-Medium; color: #404040;">{{this.verifiedCarrierNumber}}</span>
          </template>
          <img src="../assets/images/pay/icon_edit.png" width="24px" style="float:right; vertical-align: center; width: 24px; height:24px;" @click="editCarrierNumber" />
        </div>
      </div>
      <div class="div-mobile-phone" @click="editMobilePhoneNumber" v-if="this.shouldShowMobilePhone()">
        <div class="text-sm">聯絡電話（選填）</div>
        <div class="mobile-phone">
          <template v-if="this.verifiedMobilePhoneNumber === null || this.verifiedMobilePhoneNumber === ''">
            <span style="font-family: PingFangTC-Medium; color: #404040; opacity:0.4">尚未填寫聯絡電話</span>
          </template>
          <template v-if='this.verifiedMobilePhoneNumber !== null'>
            <span style="font-family: PingFangTC-Medium; color: #404040;">{{this.verifiedMobilePhoneNumber}}</span>
          </template>
          <img src="../assets/images/pay/icon_edit.png" width="24px" style="float:right; vertical-align: center; width: 24px; height:24px;" @click="editMobilePhoneNumber" />
        </div>
      </div>
      <div class="div-carrier-type" @click="showCarrierDialog" v-if="this.transactionFeeAmount() > 0">
        <div class="text-sm">發票開立方式</div>
        <div class="carrier-select">
          <div id="select_carrier">
            <span style="font-family: PingFangTC-Medium" v-if="carrier.carrier_type==='MEMBER'">悠遊付會員載具</span>
            <span style="font-family: PingFangTC-Medium" v-else-if="carrier.carrier_type==='MOBILE'">手機條碼載具 {{carrier.carrier_number}}</span>
            <span style="font-family: PingFangTC-Medium" v-else>請選擇發票開立方式</span>
          </div>
        </div>
        <div class="text-sm fee">手續費將開立發票，共 {{this.transactionFeeCount()}} 筆</div>
      </div>
      <div class="div-total">
        <div>
          <div>
            <span class="text-sm">總金額</span>
            <span class="total">{{ formatAmt(toPay.totalAmt + transactionFeeAmount()) }}元</span>
          </div>
          <div>
            <span class="text-sm" style="">(含手續費{{transactionFeeAmount()}}元)</span>
          </div>
        </div>
        <button class="btn btn-primary" style="width: 150px; float:right" @click="goNext" :disabled="goPayBtnDisable">
          {{ btnText }}
        </button>
      </div>
    </div>
    <payment-list-is-null :errorMessage="errorMessage" v-if="!billListLength"></payment-list-is-null>
    <transition>
      <section v-show="this.isShowCarrierNumberInputDialog">
        <div class="bottom-dialog" :class="this.isShowCarrierNumberInputDialog ? 'up' : 'down'">
          <div class="title-wrap">
            <div class="title"><img src="../assets/images/pay/iconRecieptCode.png" style="width:24px; height:24px; margin-right:8pt; vertical-align: bottom; ">手機條碼載具</div>
            <div class="icon-cancel" @click="closeBottomDialog"></div>
          </div>

          <div ref="bottomDialogContent" class="bottom-dialog-content-white" :class="dialogBorder ? 'dialog-navbar' : ''">
            <div style="margin: 40px 30px 0px 30px;">
              <div style="text-align: center;"><span style="">請輸入您的手機條碼載具(無需輸入”/“)</span></div>
              <div class="carrier-input">/
                <input 
                id="carrier_input"
                style="text-transform:uppercase"
                v-model.trim="carrierNumber" 
                @keyup="checkCarrierNumber"                
                type="text" 
                maxlength="7">
                </div>                            
            </div>
            <div class="required">{{ this.verifyCarrierNumberResult.text }}</div>
            <button class="btn btn-primary" style="width: 327px; align-items:center; margin-top: 40px;"  :disabled="!this.verifyCarrierNumberResult.status" @click="saveCarrierNumber">
                儲存
            </button>
          </div>
        </div>
        <div class="mask"></div>
      </section>
    </transition>
    <transition>
      <section v-show="this.isShowMobilePhoneInputDialog">
        <div class="bottom-dialog" style="height: auto;" :class="this.isShowMobilePhoneInputDialog ? 'up' : 'down'">
          <div class="title-wrap">
            <div class="title">手機號碼</div>
            <div class="icon-cancel" @click="closeMobilePhoneBottomDialog"></div>
          </div>

          <div ref="bottomDialogContent" class="bottom-dialog-content-white" :class="dialogBorder ? 'dialog-navbar' : ''">
            <div style="margin: 0px 30px 0px 30px;">
              <div style="text-align: center;"><span style="font-size:16px; color:#404040">請輸入您的手機號碼</span></div>
              <div class="mobile-phone-input">
                <input 
                  id="mobile_phone_input"
                  style="text-transform:uppercase"
                  v-model.trim="mobilePhoneNumber" 
                  @keyup="checkMobilePhoneNumber"                
                  type="number" 
                  maxlength="10">                
              </div>             
            </div>           
            <div class="required">{{ this.verifyMobilePhoneNumberResult.text }}</div>
            <ul style="margin: 16px 16px; font-size: 14px; color: #404040c0;">
              <li>僅繳交接電費時，提供手機號碼予台電</li>
              <li>手機號碼僅提供復電相關事項聯絡，不作其他用途</li>
            </ul>
            <button class="btn btn-primary" style="width: 327px; align-items:center; margin-top: 28px;" :disabled="!this.verifyMobilePhoneNumberResult.status" @click="saveMobilePhone">
                儲存
            </button>
          </div>
        </div>
        <div class="mask"></div>
      </section>
    </transition>
  </div>

 
</template>

<script>
import 'swiper/css/swiper.css';
import { queryBillList, verifyCarrierNumber, getUserConfig } from '../api/api';
import PaymentListIsNull from '../components/PaymentListIsNull';
import { formatBranchCodeToBranchName } from '../utils/branch-list';
import { formatTelcomEquipmentNumber } from '../utils/format';
import { mapActions, mapGetters } from 'vuex';
import QRcodeType from '../QRcodeType';

export default {
  name: 'go-pay',
  components: { PaymentListIsNull },
  data() {
    return {
      annotation: '',
      payBlockStyle: {  
        height: '157pt',
      },      
      qrTypeList: [],
      type: '',
      childBindList: [],
      parameter1: '',
      parameter2: '',
      parameter3: '',
      paymentCustomId: '',
      paymentItemId: '',
      paymentQueryType: '',
      billerCode: '',
      typeText: '',
      billerNickName: null,
      billList: [],
      toPay: {
        list: [],
        totalAmt: 0,
      },
      errorCode: '0',
      checkedPayType: {
        paymentMethod: '',
        paymentMethodName: '',
        paymentMethodShortName: '',
        paymentMethodRemark: '',
        isDefault: '',
        paymentMethodSerialNumber: null,
        paymentMethodImageUrl: '',
      },
      field2Name: '',
      field2Value: '',
      field3Value: '',
      isAllowMerge: 'Y',
      typeImg: '',
      carrierNumber: null,
      verifiedCarrierNumber: null,
      isShowCarrierNumberInputDialog: false,
      isShowMobilePhoneInputDialog: false,
      mobilePhoneNumber: null,
      verifiedMobilePhoneNumber: null,
      verifyMobilePhoneNumberResult : {
        status: false,
        text: '',
      },
      verifyCarrierNumberResult : {
        status: false,
        text: '',
      }
    };
  },
  mounted() {
    window.getPayTypeItem = this.getPayTypeItem;
    this.paymentQueryType = this.$route.query.payment_query_type.toString();
    if (this.$route.query.payment_item_id !== undefined && this.$route.query.payment_item_id !== '') {
      this.paymentItemId = this.$route.query.payment_item_id.toString();
    }
    if (this.$route.query.parameter1 !== undefined) {
      this.parameter1 = this.$route.query.parameter1.toString();
    }
    if (this.$route.query.parameter2 !== undefined) {
      this.parameter2 = this.$route.query.parameter2.toString();
    }
    if (this.$route.query.parameter3 !== undefined) {
      this.parameter3 = this.$route.query.parameter3.toString();
    }
    if (this.$route.query.parameter4 !== undefined) {
      this.parameter4 = this.$route.query.parameter4.toString();
    }
    this.sortOutData();
    this.getUserConfig();
  },
  filters: {
    hideName(value) {
      if (value === null) {
        return value;
      }
      let first = value.substr(0, 1);
      let last = value.substr(-1, 1);
      let hide = '';
      for (let i = 0; i < value.length - 2; i++) {
        hide += 'O';
      }
      return `${first}${hide}${last}`;
    },
  },
  computed: {
    ...mapGetters(['supportFeatures', 'carrier', 'readyToPayBill']),
    btnText() {
      if (!this.checkedBillListLength) {
        return '請選擇帳單';
      } else if (this.payMethod === 'BALANCE' && parseInt(this.checkedPayType.paymentMethodRemark) < this.toPay.totalAmt) {
        return '餘額不足';
      } else if (this.payMethod === '' || this.payMethod == null) {
        return '請選擇付款方式';
      } else {
        return '去繳費';
      }
    },
    goPayBtnDisable() {
      if (!this.checkedBillListLength) {
        return true;
      } else if (this.payMethod === 'BALANCE' && parseInt(this.checkedPayType.paymentMethodRemark) < this.toPay.totalAmt) {
        return true;
      } else if (this.payMethod === '' || this.payMethod == null) {
        return true;
      } else {
        return false;
      }
    },
    payMethod() {
      return this.checkedPayType.paymentMethod;
    },
    billListLength() {
      return this.billList.length;
    },
    checkedBillListLength() {
      return this.toPay.list.length;
    },
    errorMessage() {
      var text = '讀取中，請稍候';
      switch (this.paymentItemId) {
        case '1':
        case 'TWNCH-0103':
          if (this.errorCode === '20000') {
            text = '查無待繳的水費';
          }
          break;
        case '2':
          if (this.errorCode === '20000') {
            text = '查無待繳的路邊停車費';
          }
          break;
        case '3':
          if (this.errorCode === '20000') {
            text = '查無待繳的醫療費';
          }
      }
      return text;
    },
    checkShowDarkCard() {
      let list = ['瓦斯費', '國/社宅租金維管費'];
      if (list.includes(this.typeText)) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    ...mapActions(['sentApp', 'setReadyToPayBill']),
    formatTelcomEquipmentNumber1(equipmentNumber) {
      return formatTelcomEquipmentNumber(equipmentNumber);
    },
    checkMobilePhoneNumber() {
      const regexp = RegExp(/09[0-9]{8}/);      
      let result = regexp.test(this.mobilePhoneNumber);
      if (result) {        
        this.verifyMobilePhoneNumberResult.status = true;
        this.verifyMobilePhoneNumberResult.text = '';
      } else {
        this.verifyMobilePhoneNumberResult.status = false;
        this.verifyMobilePhoneNumberResult.text = '手機號碼格式錯誤';
      }       
    },
    checkCarrierNumber() {
      if (this.carrierNumber.length != 7) {
        this.verifyCarrierNumberResult.status = false;
        if (this.carrierNumber.length === 0) {
          this.verifyCarrierNumberResult.text = '';
          if (this.verifiedCarrierNumber !== null) {
            this.verifyCarrierNumberResult.status = true;
          }
        }
        return;
      }
      this.carrierNumber = this.carrierNumber.toUpperCase();
      const regexp = RegExp(/[A-Z0-9\\+\\.\\-]{7}/);
      let result = regexp.test(this.carrierNumber);
      
      if (result) {
        let payload = { carrier_number: '/' + this.carrierNumber };
        verifyCarrierNumber(payload).then((res) => {
          if (res.error === undefined) {
            this.verifyCarrierNumberResult.status = res.is_valid;
            this.verifyCarrierNumberResult.text = res.is_valid ? '' : '查無此載具號碼';
          } else {
            this.verifyCarrierNumberResult.status = false;
            this.verifyCarrierNumberResult.text = res.error.message;
          }
        });
      } else {
        this.verifyCarrierNumberResult.status = false;
        this.verifyCarrierNumberResult.text = '查無此載具號碼';
      }      
    },
    saveMobilePhone() {
      this.isShowMobilePhoneInputDialog = false;
      if (this.mobilePhoneNumber !== null && this.mobilePhoneNumber.length === 10) {
        this.verifiedMobilePhoneNumber = this.mobilePhoneNumber.trim();      
      } else {
        this.verifiedMobilePhoneNumber = null;
      }
    },
    saveCarrierNumber() {
      this.isShowCarrierNumberInputDialog = false;
      if (this.carrierNumber !== null && this.carrierNumber.length === 7) {
        this.verifiedCarrierNumber = '/' + this.carrierNumber;      
      } else {
        this.verifiedCarrierNumber = null;
      }
    },
    editCarrierNumber() {
      this.isShowCarrierNumberInputDialog = true;
    },
    closeBottomDialog() {
      this.isShowCarrierNumberInputDialog = false;
      setTimeout(() => {
      }, 200);
    },
    editMobilePhoneNumber() {
      this.isShowMobilePhoneInputDialog = true;
    },
    closeMobilePhoneBottomDialog() {
      this.isShowMobilePhoneInputDialog = false;
      setTimeout(() => {
      }, 200);
    },
    isElectricFeeContainWireConnectFee() {
      var isElectricFeeContainWireConnectFee = false;
      this.billList.forEach(item => {
        if (item.field4_value === '接電費') {
          isElectricFeeContainWireConnectFee = true;
        }
      });
      return isElectricFeeContainWireConnectFee;
    },
    isToPayEletricFeeMeetRequirement() {
      var sortedToPayBillMonth = [];
      var sortedBillListBillMonth = [];

      this.billList.forEach(item => {
        if (item.field4_value !== '接電費') {
          sortedBillListBillMonth.push(item.field2_value);
        }
      });
      sortedBillListBillMonth.sort();

      this.toPay.list.forEach(item => {
        if (item.field4_value !== '接電費') {
          sortedToPayBillMonth.push(item.field2_value);
        }
      });
      sortedToPayBillMonth.sort();

      for (var i=0; i<sortedToPayBillMonth.length; i++) {
        if (sortedToPayBillMonth[i] !== sortedBillListBillMonth[i]) {
          return false;
        }
      }
      return true;
    },
    isToPayOnlyContainWireConnectFee() {
      var isToPayOnlyContainWireConnectFee = true;
      this.toPay.list.forEach(item => {
        if (item.field4_value !== '接電費') {
          isToPayOnlyContainWireConnectFee = false;
          return;
        }
      });
      return isToPayOnlyContainWireConnectFee;
    },
    shouldShowCarrierNumber() {
      let shouldShowCarrierNumber = this.supportFeatures.supportCarrierNumber && (this.isGasFee() || this.isEletricFee() || this.isTaiwanWaterFee() || this.isTaipeiWaterFee());
      return shouldShowCarrierNumber;
    },
    shouldShowMobilePhone() {
      //TODO: check 接電費
      return this.isEletricFee() && this.isElectricFeeContainWireConnectFee();
    },
    goPayStyle() {
      return {
        height: this.payBlockStyle.height
      };
    },
    formatCableFeeExpiredDate(expiredDate) {
      if (expiredDate === undefined || expiredDate === null) {
        return '';
      }
      if (expiredDate.indexOf('逾期') !== -1) {
        return expiredDate;
      }
      if (expiredDate.length !== 8) {
        return expiredDate;
      }
      return expiredDate.slice(0, 4) + '/' + expiredDate.slice(4, 6) + '/' + expiredDate.slice(6, 8);
    },
    cableFeeExpiredDateStyle(expiredDate) {
      if (expiredDate !== undefined && expiredDate.indexOf('逾期') !== -1) {
        return {
          fontSize: '12px',
          color: 'rgb(218, 38, 38)',
        };
      } else {
        return {
          fontSize: '12px',
        };
      }
    },
    isGasFee() {
      return this.paymentItemId === 'TWNCH-0104';
    },
    isEletricFee() {
      return this.paymentItemId === 'TWNCH-0101';
    },
    showCarrierDialog() {
      if (this.supportFeatures.supportCarrierSetting) {
        this.$store.dispatch('sentApp', {
          action: 'openCarrierSetting',
          payload: {
          },
        });
      } else {
        alert('請更新您的 APP 以切換發票開立方式');
      }
    },
    getUserConfig() {
      getUserConfig().then((res) => {
        if (res.error === undefined) {
          this.carrier.carrier_type = res.default_einvoice_carrier_type;
          this.carrier.carrier_number = res.carrier_number;
        }
      });
    },
    getParkingFeeCarType(carType, carNumber) {
      if (carType === 'M' || carType === 'M1') {
        const regexp = RegExp(/^[A-Z]{2}[0-9]{5}$/);      
        let result = regexp.test(carNumber);
        if (result) {
          return '微電車';
        } else {
          return '機車';
        }
      } else if (carType === 'C') {
        return '汽車';
      } else if (carType === 'B') {
        return '拖車';
      } else {
        return '重機';
      }
    },
    sortOutData() {

      if (this.paymentQueryType === '1' || this.paymentQueryType === 'REALTIME-1' || this.paymentQueryType === 'REALTIME-2') {
        //手動輸入
        this.paymentCustomId = '';
        switch (this.paymentItemId) {
          case 'TWNCH-0109':
            this.typeText = '設備號碼';
            this.parameter1 = this.$route.query.parameter1;
            this.parameter2 = this.$route.query.parameter2;
            break;
          case 'TWNCH-0101':
            this.typeText = '電號';
            this.parameter1 = this.$route.query.parameter1;
            this.parameter2 = this.$route.query.parameter2;
            break;
          case '1':
          case 'TWNCH-0103':
            this.typeText = '水號';
            this.parameter1 = this.$route.query.parameter1;
            //this.paymentItemId = 1;//自然水費
            break;
          case 'TWNCH-0302':
            this.typeText = '汽機車燃料使用費';
            this.parameter1 = this.$route.query.parameter1;
            this.parameter2 = this.$route.query.parameter2;
            break;
          case 'TWNCH-0309':
            this.typeText = '汽燃費逾期繳納罰鍰';
            this.parameter1 = this.$route.query.parameter1;
            this.parameter2 = this.$route.query.parameter2;
            break;
          case 'TWNCH-0707':            
            this.parameter1 = this.$route.query.parameter1;
            if (this.parameter1 === 'newTaipeiCity') {
              this.typeText = '新北市';
            }
            break;
          case '2':
          case 'tainan-CAR':
          case 'hsinchu-CAR':
          case 'hsinchuCity-CAR':
          case 'kaohsiung-CAR':
          case 'nantou-CAR':
          case 'newTaipeiCity-CAR':
          case 'taoyuan-CAR':
          case 'keelung-CAR':
          case 'taichung-CAR':
          case 'yilan-CAR':
            //this.paymentItemId = 2;//路邊停車費
            this.parameter1 = this.$route.query.parameter1;
            this.parameter2 = this.$route.query.parameter2;
            this.typeText = this.$route.query.roadside_city + ' | ' + this.getParkingFeeCarType(this.parameter1, this.parameter2);
            break;
          case '3':
            this.typeText = '就診資訊';
            this.parameter1 = this.$route.query.parameter1;
            var parameter2 = this.$route.query.parameter2;
            var birthdayToBill = parameter2.slice(0, 4) + '/' + parameter2.slice(4, 6) + '/' + parameter2.slice(6, 8);
            this.parameter2 = birthdayToBill;
            this.parameter3 = this.$route.query.parameter3;
            //this.paymentItemId = 3;//醫療費
            break;
          case '16':
            this.typeText = '台北市';
            //this.paymentItemId = 16;//學雜費
            this.childBindList = JSON.parse(sessionStorage.getItem('childBindList'));
            break;
          case '21':
            this.typeText = '國/社宅租金維管費';
            this.typeImg = require('../assets/images/icon/PublicBuildingFee@3x.png');
            this.parameter1 = this.$route.query.parameter1;
            break;
          case '37':
            this.typeText = '金門縣水費';
            this.parameter1 = this.$route.query.parameter1;
            break;
          case '41':
            this.typeText = '平價住宅維護費';
            this.parameter1 = this.$route.query.parameter1;
            break;
          case 'KBRO':
              this.typeText = '有線電視費';
              this.typeImg = require('../assets/images/icon/TvFee@3x.png'); 
              this.parameter1 = this.$route.query.parameter1;
              this.parameter2 = this.$route.query.parameter2;
              this.parameter3 = this.$route.query.parameter3;
            break;
        }
      } else if (this.paymentQueryType === '2') {
        //掃描
        this.paymentCustomId = this.$route.query.payment_custom_id;

        if (this.paymentItemId === '21') {
          this.typeText = '國/社宅租金維管費';
          this.typeImg = require('../assets/images/icon/PublicBuildingFee@3x.png');
        } 
        if (this.paymentItemId.endsWith('-CAR')) {
          this.parameter1 = this.$route.query.parameter1;
          this.parameter2 = this.$route.query.parameter2;
          this.typeText = this.$route.query.roadside_city + ' | ' + (this.parameter1 === 'C' ? '汽車' : (this.parameter1 === 'M' ? '機車' : '拖車'));
          this.typeText = this.$route.query.roadside_city + ' | ' + this.getParkingFeeCarType(this.parameter1, this.parameter2);
        }
      } else if (this.paymentQueryType === '3') {
        //三段條碼
        this.parameter1 = this.$route.query.parameter1;
        this.parameter2 = this.$route.query.parameter2;
        this.parameter3 = this.$route.query.parameter3;
        this.billerCode = this.$route.query.biller_code;

        switch (this.paymentItemId) {
          case '14':
          case 'TWNCH-1402':
            this.typeText = '稅費別';
            //this.paymentItemId = 14;//地方稅
            break;
          case 'TWNCH-0104':
            this.typeText = '瓦斯費';
            this.typeImg = require('../assets/images/icon/GasFee@3x.png');
            break;
          case 'KBRO':
            this.typeText = '有線電視費';
            this.typeImg = require('../assets/images/icon/TvFee@3x.png');
            break;
          case 'TWNCH-0101':
            this.typeText = '電號';
            break;
          case 'TWNCH-0707':
            this.typeText = '學雜費';
            break;
          case 'NHI':
            this.typeText = '';
            break;
        }
      }
      this.getPaymentType();
      this.getBillList();
    },
    getBillList() {
      var form = {
        //單筆查詢
        payment_item_id: this.paymentItemId,
        payment_query_type: this.paymentQueryType,
        parameter1: this.parameter1,
        parameter2: this.parameter2,
        parameter3: this.parameter3,
        payment_custom_id: this.paymentCustomId,
        biller_code: this.billerCode,
      };
      let listArray = []; //多筆查詢
      let formArray = {
        payment_item_id: this.paymentItemId,
        payment_query_type: this.paymentQueryType,
        parameter1: this.parameter1,
        parameter2: this.parameter2,
        parameter3: this.parameter3,
        payment_custom_id: this.paymentCustomId,
      };
      if (this.paymentItemId === '16') {
        if (this.paymentQueryType === '1') {
          this.childBindList.forEach((el) => {
            listArray.push({
              payment_query_type: this.paymentQueryType,
              parameter1: el.student_id_number,
              parameter2: el.student_name,
            });
          });
          formArray.bill_query_parameter_list = listArray;
        }
      }

      let query = this.paymentItemId === '16' ? formArray : form;
      if (this.readyToPayBill !== null) {
        this.handleQueryBillResult(this.readyToPayBill);
        this.setReadyToPayBill(null);
      } else {
        queryBillList(query).then((res) => {      
          this.handleQueryBillResult(res);
        });
      }
    },
    handleQueryBillResult(res) {
      if (res.error === undefined) {  
          this.billerNickName = res.biller_nick_name;        
          this.billList = res.bill_list;        
          this.isAllowMerge = res.is_allow_merge;
          this.annotation = res.annotation;        
          if (this.billList) {
            this.billList.forEach((el) => {
              if (el.amount) {
                el.amt = el.amount;
              }
              if (el.is_allow_payment === undefined) {
                el.is_allow_payment = true;
              }
              if (this.type === 'cableFee') {
                this.$set(el, 'checked', true);
                this.toPay.list.push(el);
                this.toPay.totalAmt += el.amt;
              } else if (this.isAllowMerge === 'A') {
                this.$set(el, 'checked', true);
                this.$set(el, 'disabled', true);
                this.toPay.list.push(el);
                this.toPay.totalAmt += el.amt;
              } else {
                this.$set(el, 'checked', false);
              }
              
            });
          }          
          this.$store.dispatch('sentApp', {
            action: 'getPaymentMethodList',
            payload: {
              payment_method_list: this.supportFeatures.withSupportPaymentMethod ? res.with_support_payment_method_list : res.payment_method_list,
            },
          });   
          if (this.shouldShowCarrierNumber() && res.carrier_number !== undefined && res.carrier_number !== null && res.carrier_number.length === 8) {
              this.carrierNumber = res.carrier_number.substr(1);
              this.verifiedCarrierNumber = res.carrier_number;
              this.verifyCarrierNumberResult.status = true;
          }
          if (this.transactionFeeAmount() > 0 && !this.supportFeatures.supportCarrierSetting) {
            alert('請更新您的 APP 以切換發票開立方式');
            this.$router.back();
          }
        } else {
          alert(res.error.message);
          this.billList = [];
          this.errorCode = res.error.code;
        }
        this.calculatePayBlockHeight();
    },
    isTaiwanWaterFee() {
      return this.paymentItemId === 'TWNCH-0103';
    },
    isTaipeiWaterFee() {
      return this.paymentItemId === '1';
    },
    formatAmt(num) {
      var parts = num.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
    formatBranchCodeToBranchName(branchCode) {
      return formatBranchCodeToBranchName(branchCode);
    },
    transactionFeeCount() {
      var count = 0;
      this.toPay.list.forEach((i) => {      
        if (i.transaction_fee !== undefined && i.transaction_fee > 0) {
          count++; 
        }
      });
      return count;
    },
    transactionFeeAmount() {
      var amount = 0;
      this.toPay.list.forEach((i) => {      
        if (i.transaction_fee !== undefined && i.transaction_fee > 0) {
          amount += i.transaction_fee; 
        }
      });
      return amount;
    },
    clickBill(item) {
      if (!item.is_allow_payment) {
        alert('此筆帳單無法繳費，請選擇其他帳單!');
        return;
      }
      if (this.isAllowMerge === 'A') {
        return false;
      }
      item.checked = !item.checked;
      if (this.checkedBillListLength > 0 && this.isAllowMerge==='N' && item.checked) {
        alert('此繳費最多只能選擇一筆!');
        item.checked = false;
      } else if (item.checked) {
        this.toPay.list.push(item);
        this.toPay.totalAmt += item.amt;
      } else {
        var list = this.toPay.list;
        list.splice(
          list.findIndex((e) => e === item),
          1
        );
        this.toPay.totalAmt -= item.amt;
      }
      this.calculatePayBlockHeight();
    },
    calculatePayBlockHeight() {
      var payBlockHeight = 175;
      if (this.shouldShowCarrierNumber() > 0) {
        payBlockHeight += 33;        
      }
      if (this.shouldShowMobilePhone()) {
        payBlockHeight += 33;        
      }
      if (this.transactionFeeAmount()) {
        payBlockHeight += 93;        
      }
      this.payBlockStyle.height = (payBlockHeight + 'pt');
    },
    showPayTypeList() {
      this.$store.dispatch('sentApp', {
        action: 'isShowPayTypeList',
        payload: {},
      });
    },
    getPayTypeItem(
      paymentMethod,
      paymentMethodName,
      paymentMethodShortName,
      paymentMethodRemark,
      isDefault,
      paymentMethodSerialNumber,
      paymentMethodImageUrl
    ) {
      this.checkedPayType = {
        paymentMethod: paymentMethod,
        paymentMethodName: paymentMethodName,
        paymentMethodShortName: paymentMethodShortName,
        paymentMethodRemark: paymentMethodRemark,
        isDefault: isDefault,
        paymentMethodSerialNumber: paymentMethodSerialNumber,
        paymentMethodImageUrl: paymentMethodImageUrl,
      };
    },
    goNext() {
      
      //this.$router.push({path: '/checkPayInformation'});
      if (this.isEletricFee()) {
        if (this.isToPayOnlyContainWireConnectFee()) {
          alert('接電費無法單獨繳納');
          return;
        }

        if (!this.isToPayEletricFeeMeetRequirement()) {
          alert('您有待繳的逾期帳單\n請於本次一併繳納');
          return;
        }

        if (this.isElectricFeeContainWireConnectFee() && this.verifiedMobilePhoneNumber !== null) {
          this.toPay.list[0].btId += ('|' + this.verifiedMobilePhoneNumber);
        }
      }
      

      var payload = {
        bill_list: this.toPay.list,
        total_amt: this.toPay.totalAmt + this.transactionFeeAmount(),
        payment_amt: this.toPay.totalAmt,
        payment_method: this.checkedPayType.paymentMethod,
        payment_method_name: this.checkedPayType.paymentMethodName,
        payment_method_short_name: this.checkedPayType.paymentMethodShortName,
        payment_method_remark: this.checkedPayType.paymentMethodRemark,
        is_default: this.checkedPayType.isDefault,
        payment_method_serial_number: this.checkedPayType.paymentMethodSerialNumber === '\"\"' ? null : this.checkedPayType.paymentMethodSerialNumber,
        payment_method_image_url: this.checkedPayType.paymentMethodImageUrl,
        carrier_number: this.verifiedCarrierNumber,
      };

      if (this.transactionFeeAmount() > 0) {        
        if (!this.supportFeatures.supportCarrierSetting) {
          alert('請更新您的 APP 以選擇發票開立方式完成繳費');
          this.$router.back();
          return;
        }
        if (this.carrier.carrier_type === 'MEMBER') {
          payload.carrier_type_description = '悠遊付會員載具';
          payload.carrier_type = 'MEMBER';
          payload.carrier_number = null;        
        } else if (this.carrier.carrier_type === 'MOBILE') {          
          payload.carrier_type_description = '手機條碼載具';
          payload.carrier_type = 'MOBILE';
          payload.carrier_number = this.carrier.carrier_number;
        }        
      } else if (this.shouldShowCarrierNumber() && this.verifiedCarrierNumber != undefined && this.verifiedCarrierNumber !== null && this.verifiedCarrierNumber.startsWith('/')) {
          payload.carrier_type_description = '手機條碼載具';
          payload.carrier_type = 'MOBILE';
      }
      

      if (this.paymentItemId === '16') {
        payload.type = 16;
      } else {
        payload.type = '';
      }
      this.$store.dispatch('sentApp', {
        action: 'goPay',
        payload: payload,
      });
    },
    formatSpace(number) {
      if (number.length) {
        var formatNumber = decodeURIComponent(number).replace(/\s+/g, '');
        if (this.type === 'waterFee') {
            if (formatNumber.length < 10) {
              formatNumber = formatNumber.padEnd(10, '0');
            }
            return formatNumber.slice(0, 1) + ' ' + formatNumber.slice(1, 3) + ' ' + formatNumber.slice(3, 9) + ' ' + formatNumber.slice(9, 10);
        } else if (this.type === 'taiwanWaterFee') {          
          if (formatNumber.length < 11) {
            return formatNumber;
          }
          return formatNumber.slice(0, 2) + ' ' + formatNumber.slice(2, 10) + ' ' + formatNumber.slice(10, 11);      
        } else if (this.type === 'electricFee') {
          if (formatNumber.length < 11) {
            formatNumber = formatNumber.padEnd(11, '0');
          }
          return (
            formatNumber.substr(0, 2) +
            ' ' +
            formatNumber.substr(2, 2) +
            ' ' +
            formatNumber.substr(4, 4) +
            ' ' +
            formatNumber.substr(8, 2) +
            ' ' +
            formatNumber.substr(10, 1)
          );
        }
      }
    },
    getPaymentType() {
      this.qrTypeList = QRcodeType;
      if (this.paymentQueryType !== '2' || this.paymentItemId === '16' || this.paymentItemId.endsWith('-CAR')) {
        switch (this.paymentItemId) {
          case '1':
            this.type = 'waterFee';
            break;
          case 'TWNCH-0103':
            this.type = 'taiwanWaterFee';
            break;
          case 'TWNCH-0302':
          case 'TWNCH-0309':
            this.type = 'carFuelFee';
            break;
          case '2':
          case 'tainan-CAR':
          case 'hsinchu-CAR':
          case 'hsinchuCity-CAR':
          case 'kaohsiung-CAR':
          case 'nantou-CAR':
          case 'newTaipeiCity-CAR':
          case 'keelung-CAR':
          case 'taoyuan-CAR':
          case 'taichung-CAR':
          case 'yilan-CAR':
            this.type = 'roadsideParking';
            break;
          case '3':
            this.type = 'medicalFee';
            break;
          case '14':
          case 'TWNCH-1402':
            this.type = 'tax';
            break;
          case '16':
            this.type = 'tuitionFee';
            break;
          case 'TWNCH-0707':
            this.type = 'otherTuitionFee';
            break;
          case 'TWNCH-0101':
            this.type = 'electricFee';
            break;
          case 'TWNCH-0104':
            this.type = 'gasFee';
            break;
          case 'KBRO':
            this.type = 'cableFee';
            break;
          case 'TWNCH-0109':
            this.type = 'telcomFee';
            break;
            case 'NHI':
              this.type = 'healthyInsurance';
              break;
        }
      } else {
        this.qrTypeList.forEach((i) => {
          if (this.paymentItemId === i.paymentItemId) {
            this.typeText = i.text;
          }
        });
      }
    },
  },
};
</script>

<style scoped type="text/scss">
html,
body {
  overflow: hidden;
  background: #fff !important;
}

.dark-card {
  margin: 20pt;
  padding: 24pt;
}

.dark-card .info {
  color: #c7c7c7;
  font-size: 16px;
  margin-bottom: 5pt;
}

.dark-card .main {
  font-size: 22px;
}

.list {
  position: relative;
  min-height: 45vh;
}

.line {
  height: 1px;
  background: #c7c7c7c7;
  width: 100%;
  margin-bottom: 16px;
}

.text {
  font-family: PingFangTC-Regular;
  word-break: break-all;
}

.list .item {
  background: #fff;
  align-items: center;  
  padding: 0 15pt 0 15pt;
  font-size: 16px;
  margin-bottom: 0;
}

.item .amount-block {
  width: 50%;
  align-self: flex-end;
  background: yellow;;
}

.item .row {
  display: flex;
}

.list .item:last-child {
  margin-bottom: 0;
}

.item .row {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
}

.row .flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* width: calc(100% - 50px); */
  width: calc(100%);
  justify-content: inherit;
  padding: 10pt 0;
}

.row .right {
  display:flex; 
  flex-direction: row; 
  align-items: center
}

.row .amount {
  margin-right: 15px;
}

.item:not(:last-child) .flex {
  border-bottom: 1px solid rgba(64, 64, 64, 0.1);
}

.overflow {
  background: #f9f9f9;
  overflow-y: scroll;
  position: relative;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  -webkit-overflow-scrolling: touch;
}

.text-gray2 {
  display: flex;
  flex-direction: column;
  max-width: 222px;
}

.row-disable {
  opacity: 0.75;
}

.text-md {
  font-family: PingFangTC-Medium;
  color: rgb(64, 64, 64);
}

.annotation {
  background-color: #007ac8;
  color: white;
  font-size: 14px;
  font-family: PingFangTC-Medium;
  text-align: center;
  padding: 10px;  
}
.fee {
  background: rgba(64, 64, 64, 0.1);
  color: rgba(64, 64, 64, 0.75);
  height: 36px;
  text-align: left;
  padding-left: 12px;
  line-height: 36px;
  width: 100%;
  font-size: 14px;
}
.error-text {
  font-size: 12px;
  color: rgba(218, 38, 38, 1);
}


.bottom-dialog .bottom-dialog-content {
}

@keyframes slideUp {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes slideDown {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
}

.up {
  animation: slideUp 0.3s ease-in-out both;
}

.down {
  animation: slideDown 0.3s ease-in-out both;
}

</style>
